import React from 'react';
import ProgressStatusBar from '../customer/progress_status_bar';
import FinancingMethodSelector from './financing_method_selector';

const WizardV2 = ({
  steps,
  currentStep,
  onBeforeStepChange,
  backButtonCls,
  backButtonChildren,
  nextButtonCls,
  nextButtonChildren,
  showSteps,
  proposal,
  customer,
}) => {
  const canonicalSteps = steps.map(({ label, icon, component, additionalClassName }) => ({
    label,
    icon,
    additionalClassName,
    content: component,
  }));

  return (
    <div className={'proposal-page'}>
      <ProgressStatusBar
        belowBreadCrumbs={<FinancingMethodSelector proposal={proposal} customer={customer} />}
        steps={canonicalSteps}
        activeIndex={currentStep}
        showSteps={showSteps}
        {...{ onBeforeStepChange }}
      />

      <div className={'footer-buttons'}>
        {currentStep > 0 && (
          <button
            id="prev-button"
            className={backButtonCls}
            onClick={() => onBeforeStepChange(currentStep, currentStep - 1)}
          >
            {backButtonChildren}
          </button>
        )}
        {currentStep < steps.length - 1 && (
          <button
            id="next-button"
            className={nextButtonCls}
            onClick={() => onBeforeStepChange(currentStep, currentStep + 1)}
          >
            {nextButtonChildren}
          </button>
        )}
      </div>
    </div>
  );
};

export default WizardV2;
